import React, { useState } from "react";
import { PlusCircle } from "phosphor-react";
import './wishlistcard.css';
import WishListIcon from "../WishlistIcon/WishListIcon";
import ProductQuantity from "../ProductQuantity/ProductQuanity";
import AddtoCartBtn from "../AddtoCartbtn/AddtoCartBtn";
import ProductCardCartBtn from "../ProductCardCartBtn/ProductCartCardBtn";
const WishlistCard = ({product }) => {
  const {defaultImageUrl,price="",name="",sizes=[]} = product || {};
  const [isHoveredAddToCart, setIsHoveredAddToCart] = useState(false);
  return (
    <div className="wishlistcardcontainer">
      <div className="wishlistcardimageandheart" >
        <img
          className="wishlistcardimage"
          src={defaultImageUrl}
          alt="Product Image"
        />
        <WishListIcon isWishlist={product?.isWishlist} id={product._id} pagename="wishlist" />
      </div>
      <div className="wishlist-card-details">
        <div className="ellipsis">
        <div className="wishlistproduct-name t6 font-medium">
         {name}
        </div>
        {/* <div className="wishlistproduct-price t6 font-medium">
        ₹ {price}
        </div> */}
        {product.discountPrice?
          <div className="wishlistproduct-price">
          <h5 className={`t6 canceledmrp`}>
            ₹ {product.mrp}
            </h5>
            <h5 className={`t6`}>
            ₹ {product.discountPrice}
            </h5>
            </div>
            :
            <h5 className={`t6`}>
            ₹ {product.livePrice}
            </h5>
          }
        <div class="card-text" className="t8 wishlistcardcategorytext">MEN | TSHIRT</div>
        </div>
        
        <div className="productcard-color">
          <div className="product-colors">
            {product.colors.map((color, index) => (
              index >= 2 ? (
                <div key={index} className="t8 font-semibold">+ {index - 1}</div>
              ) : (
                <div key={index} className= "colouredcircle" style={{ backgroundColor: color }}></div>
              )
            ))}
          </div>
        </div>
      </div>
      <ProductCardCartBtn name="Add to bag" product = {product}/>
    </div>
  )
}

export default WishlistCard;